import React from 'react';
import type {SxProps} from '@mui/material';
import {ActionButtonV2} from 'components/button/ActionButtonV2';
import {FlexBox, Layout} from 'components/layout';
import {Spacer} from 'components/spacer';
import type {DialogActionItem, DialogItem} from './types';

type Props = {
  dialogItems?: DialogItem[];
};

const hiddenSx: SxProps = {
  opacity: '0!important',
  visibility: 'hidden!important',
};

/**
 * Renders a dialog action as an {@link ActionButtonV2}, dropping the
 * dialog-only props so they are not forwarded to the underlying MUI Button.
 */
const DialogActionButton: React.FC<DialogActionItem> = ({
  hide: _hide,
  itemType: _itemType,
  alignLeft: _alignLeft,
  ...buttonProps
}) => <ActionButtonV2 {...buttonProps} />;

export const DialogItems: React.FC<Props> = ({dialogItems}) => {
  const hasLeftItems = dialogItems?.some(a => a.alignLeft);
  const rightItems = hasLeftItems
    ? dialogItems?.filter(a => !a.alignLeft)
    : dialogItems;
  const leftItems = hasLeftItems
    ? dialogItems?.filter(a => a.alignLeft)
    : undefined;

  return dialogItems ? (
    hasLeftItems ? (
      <FlexBox horizontal flex={1} justifyContent={'space-between'}>
        <Layout horizontal>
          {(leftItems ?? []).map((item, i) => (
            <FlexBox
              horizontal
              center
              key={i}
              sx={item.hide ? hiddenSx : undefined}>
              {item.itemType === 'action' ? (
                <DialogActionButton {...item} />
              ) : (
                item.render()
              )}
              {i < dialogItems.length - 1 && <Spacer size={2} />}
            </FlexBox>
          ))}
        </Layout>
        <FlexBox horizontal center>
          {(rightItems ?? []).map((item, i) => (
            <FlexBox
              horizontal
              center
              key={i}
              sx={item.hide ? hiddenSx : undefined}>
              {item.itemType === 'action' ? (
                <DialogActionButton {...item} />
              ) : (
                item.render()
              )}
              {i < (rightItems?.length ?? 0) - 1 && <Spacer size={2} />}
            </FlexBox>
          ))}
        </FlexBox>
      </FlexBox>
    ) : (
      <FlexBox horizontal center right>
        {dialogItems.map((item, i) => (
          <FlexBox
            horizontal
            center
            key={i}
            sx={item.hide ? hiddenSx : undefined}>
            {item.itemType === 'action' ? (
              <DialogActionButton {...item} />
            ) : (
              item.render()
            )}
            {i < dialogItems.length - 1 && <Spacer size={2} />}
          </FlexBox>
        ))}
      </FlexBox>
    )
  ) : null;
};
